import { Loader } from "rsuite";
import "./style.scss";
const CustomLoader = () => {
  return (
    <div
      style={{
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        position: "fixed",
        zIndex: 1051,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#181818CC",
        flexDirection: "column",
      }}
    >
      <Loader />
    </div>
  );
};
export default CustomLoader;
